import { type NavigationGuardWithThis } from 'vue-router'
import { Routes } from '~/router/routes'
import NoLicenseAccess from '~/pages/general/no-license-access/Index.vue'
import { usePropertyStore } from '~/store/property/property'

const unguardedRoutes: string[] = [Routes.GENERAL_SELECT_PROPERTY, Routes.ENTRYPOINT_LOGIN_INDEX]

const checkLicenseGuard: NavigationGuardWithThis<undefined> = (to) => {
  const propertyStore = usePropertyStore()
  const route = to.matched[to.matched.length - 1]

  if (
    !propertyStore.isLoaded ||
    propertyStore.property.active ||
    !route ||
    unguardedRoutes.includes(String(route.name))
  ) {
    return
  }

  route.components = { default: NoLicenseAccess }
}

export default checkLicenseGuard
